import { type QueryClient } from "@tanstack/react-query";
import {
  type CollectionResponse,
  type CollectionsResponse,
} from "~/api/generated/model";
import {
  getProposalCollections,
  useGetProposalCollectionsQueryOptions,
} from "~/api/generated/proposal-collections/proposal-collections";

export type SavedProposalCollection = CollectionResponse;

const LEGACY_LOCAL_STORAGE_KEY = "temp_client_side_proposal-collections";

// TODO: Remove once members have had time to load their Collections from the server; the old localStorage Collections are dropped, not imported.
const clearLegacyLocalStorage = () => {
  try {
    localStorage.removeItem(LEGACY_LOCAL_STORAGE_KEY);
  } catch {
    // Storage can be unavailable (private mode, blocked site data); nothing to clear then.
  }
};

const selectCollections = ({ collections }: CollectionsResponse) => collections;

export const proposalCollectionsQueries = {
  all: () =>
    useGetProposalCollectionsQueryOptions({
      query: {
        staleTime: 60_000 /* 1 min */,
        retry: 0,
        queryFn: ({ signal }) => {
          clearLegacyLocalStorage();
          return getProposalCollections(undefined, signal);
        },
        select: selectCollections,
      },
    }),
};

/**
 * `select` only runs for query observers, so a route loader has to unwrap the
 * cached response itself.
 */
export const ensureProposalCollections = async (queryClient: QueryClient) =>
  selectCollections(
    await queryClient.ensureQueryData(proposalCollectionsQueries.all()),
  );
